import cx from 'classnames'
import {
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
  useId,
  useState,
} from 'react'
import { Icons } from 'src/components/Icon'
import { PictureProps } from 'src/components/Picture'

import * as SC from './styled'

export type IllustrationProps = {
  className?: string
  pictureProps: PictureProps
  caption?: string
  texts?: {
    open?: string
    close?: string
  }
}

const Illustration: ForwardRefExoticComponent<
  IllustrationProps & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, IllustrationProps>(
  ({ className, pictureProps, caption, texts }, ref) => {
    const id = useId()
    const [open, setOpen] = useState(false)
    const handleToggle = (force?: boolean) => {
      setOpen(force ?? !open)
    }
    return (
      <SC.Container className={cx('Illustration', className)} ref={ref}>
        <SC._Picture {...pictureProps} />
        {caption && (
          <SC.Content data-open={open}>
            <SC.Open
              type="button"
              onClick={() => handleToggle(true)}
              aria-expanded={false}
              aria-controls={`${id}-content`}
            >
              <SC.OpenIcon icon={Icons.plus} title={texts?.open} />
            </SC.Open>
            <SC.Caption hidden={!open} id={`${id}-content`}>
              {caption}
            </SC.Caption>
            <SC.Close
              type="button"
              onClick={() => handleToggle(false)}
              aria-expanded={true}
              aria-controls={`${id}-content`}
            >
              <SC.CloseIcon icon={Icons.minus} title={texts?.close} />
            </SC.Close>
          </SC.Content>
        )}
      </SC.Container>
    )
  }
)

Illustration.displayName = 'Illustration'

export default Illustration
